module.exports = __webpack_public_path__ + "static/media/zadig&voltaire.fbe3bfc7.svg";